import React from 'react';

import Intro from '~/kits/general/scripts/slides/Intro';
import BarChartRace from '~/kits/general/scripts/slides/BarChartRace';
import RightMap from '~/kits/general/scripts/slides/RightMap';
import ParliamentRightWing from '~/kits/general/scripts/slides/ParliamentRightWing';
import ParliamentEuSceptics from '~/kits/general/scripts/slides/ParliamentEuSceptics';
import ParliamentBrexit from '~/kits/general/scripts/slides/ParliamentBrexit';
import TurnoutMap from '~/kits/general/scripts/slides/TurnoutMap';
import GreenMap from '~/kits/general/scripts/slides/GreenMap';
import LeftMap from '~/kits/general/scripts/slides/LeftMap';
import LiberalMap from '~/kits/general/scripts/slides/LiberalMap';
import SocialistsMap from '~/kits/general/scripts/slides/SocialistsMap';
import Outro from '~/kits/general/scripts/slides/Outro';
import WinLoss from '~/kits/general/scripts/slides/WinLoss';

export default [{
  name: 'Rechte bei der Europawahl',
  comp: Intro,
  title: 'So stark ist Europa nach rechts gerückt',
  text: `
    Der große Knall ist zwar ausgeblieben. Doch der Anteil der EU-Abgeordneten rechter Parteien ist so hoch wie noch nie. Der Rechtsruck in fünf Grafiken.
  `
}, {
  name: 'Länderanteil',
  comp: BarChartRace,
  title: 'Mit der Jahrtausendwende wurden Europas Rechte stärker',
  text: `Anteil rechter Abgeordneter im Europaparlament je Mitgliedsland`,
  yearTexts: {
    1979: 'Text für 1979 Lorem Ipsum dolor sit',
    1989: 'Text für 1989 Lorem Ipsum dolor sit',
    1994: 'Text für 1994 Lorem Ipsum dolor sit',
    1999: 'Text für 1999 Lorem Ipsum dolor sit',
    2004: 'Text für 2004 Lorem Ipsum dolor sit',
    2009: 'Text für 2009 Lorem Ipsum dolor sit',
    2014: 'Text für 2014 Lorem Ipsum dolor sit',
    2019: 'Text für 2019 Lorem Ipsum dolor sit',
  }
}, {
  name: 'Anzahl der Sitze pro Land',
  comp: RightMap,
  title: 'Woher die rechten Abgeordneten kommen',
  text: `
  Bei der Zustimmung im eigenen Land liegt Ungarn im Populisten-Ranking vorn, die meisten Sitze aus dem Lager hat aber die Brexit-Partei, Italien und Polen.
  `
}, {
  name: 'Anteil der Sitze insgesamt',
  comp: ParliamentRightWing,
  title: 'Jeder Fünfte ist Mitglied einer rechten Partei',
  text: `
    Die Rechtspopulisten haben vielerorts schwächer als erwartet abgeschnitten, ihren Anteil im Europarlament dennoch stark ausgebaut.
  `
}, {
  name: 'EU-Skeptiker',
  comp: ParliamentEuSceptics,
  title: 'Jeder Dritte im Parlament ist ein EU-Skeptiker',
  text: `
    Sie sitzen im Europarlament, um gegen die EU zu arbeiten. Neben den Rechten lehnen auch andere die EU ab, insbesondere auf der linken Seite.
  `
}, {
  name: 'Wahlbeteiligung 2019 ',
  comp: TurnoutMap,
  title: 'Trendwende bei der Wahlbeteiligung',
  text: `
    Lichtblick: Europa ist Wählern wieder wichtiger
  `
},

/* 

 {
  name: 'Die Anderen',
  comp: WinLoss,
  title: 'Gewinner und Verlierer der Europawahl 2019',
  text: `
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
    Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat
  `
}, {
  name: 'Grünen',
  comp: GreenMap,
  title: 'Grünen Title Lorem Ipsum dolor sit',
  text: `
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
  `
}, {
  name: 'Linke',
  comp: LeftMap,
  title: 'Linken Title Lorem Ipsum dolor sit',
  text: `
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
  `
}, {
  name: 'Liberale',
  comp: LiberalMap,
  title: 'Liberalen Title Lorem Ipsum dolor sit',
  text: `
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
  `
}, {
  name: 'Sozialdemokraten',
  comp: SocialistsMap,
  title: 'Soc Title Lorem Ipsum dolor sit',
  text: `
    Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.
  `
}, 

*/


{
  name: 'Info',
  comp: Outro,
  title: ' ',
  text: `
     
  `
}];